import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, paramCheck } from '../../utils';

export interface ShowToastOption extends Partial<GeneralInvokeOption> {
  title?: string;
  message?: string;
  icon?: string;
  duration?: number;
  mask?: Boolean;
  image?: string;
  invalidParamObj?: '';
}

// 显示loading提示框，需主动调用ma.hideLoading才能关闭提示框
export function showToast(option: ShowToastOption) {
  if (!option?.title && !option?.message) {
    return logErrorAndRunFail(
      APINames.Native.SHOW_TOAST,
      option,
      'parameter error: prompt message should be String instead of Undefined.'
    );
  }
  option.title = option.title ?? option.message;
  if (
    paramCheck(APINames.Native.SHOW_TOAST, option, {
      title: '',
      message: '',
      icon: '',
      duration: 0,
      mask: false,
      image: ''
    })
  ) {
    // 校验icon合法性
    const validIcon: Array<string> = ['success', 'error', 'loading', 'none'];
    if (option?.icon && validIcon.indexOf(option?.icon) === -1) {
      return logErrorAndRunFail(
        APINames.Native.SHOW_TOAST,
        option,
        'parameter error:parameter.icon contains invalid values.'
      );
    }
    const fixedOption = Object.assign(
      {
        icon: 'success',
        duration: 1500,
        mask: false
      },
      option
    );
    return MacleJSBridge.beforeInvoke(APINames.Native.SHOW_TOAST, fixedOption);
  }
  return option.invalidParamObj;
}
